export const SETPRJLISTFORTKT = "SETPRJLISTFORTKT";
export const SETSUBPRJLIST = "SETSUBPRJLIST";
export const SETISSUETYPELIST = "SETISSUETYPELIST";
export const SETTICKETDETAIL = "SETTICKETDETAIL";
export const SETTICKETLIST = "SETTICKETLIST";
export const SETTKTCOLUMNLIST = "SETTKTCOLUMNLIST";
export const SETUSERTKTCOLUMNLIST = "SETUSERTKTCOLUMNLIST";
export const SETUSERDEFAULTLIST = "SETUSERDEFAULTLIST";
export const CLEARDOC = "CLEARDOC";
export const SETTICKETCOUNTLIST = "SETTICKETCOUNTLIST";
export const SETAGENTLIST = "SETAGENTLIST";
export const SETREPLYMAILLIST = "SETREPLYMAILLIST";
export const SETCLOSEDEMAILCONTENT = "SETCLOSEDEMAILCONTENT";
export const SETUSERREVIEWEMAILCONTENT = "SETUSERREVIEWEMAILCONTENT";
export const SETTICKETSBASICFILTERDATA = "SETTICKETSBASICFILTERDATA";
export const SETDELAYEDREASONLIST = "SETDELAYEDREASONLIST";
export const SETAGEDTICKETREVIEWLIST = "SETAGEDTICKETREVIEWLIST";
export const SET_RESOLUTION_BY_TICKET_ID = "SET_RESOLUTION_BY_TICKET_ID";
export const SET_ALL_ROOT_CAUSES = "SET_ALL_ROOT_CAUSES";
